import { atom } from 'jotai'

export const trackStateAtom = atom(false)
export const activeStateAtom = atom(false)
export const mobileStateAtom = atom(false)
